export default "__VITE_ASSET__uD4QtKmK__"